// mutations
const CAFETERIA_ENLISTMENT_ALL = (state, cafeteriaEnlistment) => {
  if (cafeteriaEnlistment.code === 1) {
    state.cafeteriaEnlistment = cafeteriaEnlistment.data
    state.status = 'success'
  } else {
    alert(cafeteriaEnlistment.message)
    state.status = 'error'
  }
}

const CAFETERIA_ENLISTMENT_FORM = (state, cafeteriaEnlistment) => {
  if (cafeteriaEnlistment.code === 1) {
    state.cafeteriaEnlistment = cafeteriaEnlistment.data
    state.status = 'success'
  } else {
    alert(cafeteriaEnlistment.message)
    state.status = 'error'
  }
}

const CAFETERIA_ENLISTMENT_SHOW = (state, cafeteriaEnlistment) => {
  if (cafeteriaEnlistment.code === 1) {
    state.cafeteriaEnlistment = cafeteriaEnlistment.data
    state.status = 'success'
  } else {
    alert(cafeteriaEnlistment.message)
    state.status = 'error'
  }
}

const CAFETERIA_ENLISTMENT_CREATE = (state, cafeteriaEnlistment) => {
  if (cafeteriaEnlistment.code === 1) {
    state.cafeteriaEnlistment = cafeteriaEnlistment.data
    state.status = 'success'
    alert(cafeteriaEnlistment.message)
  } else {
    alert(cafeteriaEnlistment.message)
    state.status = 'error'
  }
}

const CAFETERIA_ENLISTMENT_UPDATE = (state, cafeteriaEnlistment) => {
  if (cafeteriaEnlistment.code === 1) {
    state.cafeteriaEnlistment = cafeteriaEnlistment.data
    state.status = 'success'
    alert(cafeteriaEnlistment.message)
  } else {
    alert(cafeteriaEnlistment.message)
    state.status = 'error'
  }
}

const CAFETERIA_ENLISTMENT_DELETE = (state, cafeteriaEnlistment) => {
  if (cafeteriaEnlistment.code === 1) {
    state.cafeteriaEnlistment = cafeteriaEnlistment.data
    state.status = 'success'
    alert(cafeteriaEnlistment.message)
  } else {
    alert(cafeteriaEnlistment.message)
    state.status = 'error'
  }
}

export default {
  CAFETERIA_ENLISTMENT_ALL,
  CAFETERIA_ENLISTMENT_FORM,
  CAFETERIA_ENLISTMENT_SHOW,
  CAFETERIA_ENLISTMENT_CREATE,
  CAFETERIA_ENLISTMENT_UPDATE,
  CAFETERIA_ENLISTMENT_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/enlistment/mutations.js